import { LogoMark } from "@/components/Logo";
import { scrollToSection } from "@/lib/scroll";
import { CONTACT } from "@/lib/site";

export default function Footer() {
    return (
        <footer className="border-t border-line pt-14 overflow-hidden">
            <div className="px-5 md:px-10 flex flex-col md:flex-row justify-between gap-10 pb-16">
                <div className="flex items-center gap-3">
                    <LogoMark size={30} />
                    <div>
                        <p className="font-display font-extrabold uppercase tracking-tight">Hitanshu Shah</p>
                        <p className="text-[10px] uppercase tracking-[0.2em] text-inkdim">
                            Writer · Cinematographer · Editor
                        </p>
                    </div>
                </div>
                <div className="flex flex-wrap gap-6 md:gap-8 text-[11px] font-bold uppercase tracking-[0.18em]">
                    {[
                        ["Work", "#work"],
                        ["About", "#about"],
                        ["Services", "#services"],
                        ["Contact", "#contact"],
                    ].map(([l, h]) => (
                        <button
                            key={h}
                            data-testid={`footer-link-${h.slice(1)}`}
                            onClick={() => scrollToSection(h)}
                            className="hover:opacity-60 transition-opacity duration-300 cursor-pointer"
                        >
                            {l}
                        </button>
                    ))}
                </div>
                <a
                    href={`mailto:${CONTACT.email}`}
                    data-testid="footer-email"
                    className="font-display font-bold tracking-tight text-lg hover:opacity-60 transition-opacity"
                >
                    {CONTACT.email}
                </a>
            </div>

            <div className="px-2 select-none" aria-hidden="true">
                <p className="text-outline font-display font-black uppercase leading-[0.8] tracking-[-0.02em] text-[12vw] whitespace-nowrap text-center translate-y-[0.14em]">
                    Hitanshu Shah
                </p>
            </div>

            <div className="border-t border-line px-5 md:px-10 py-5 flex flex-col md:flex-row justify-between gap-2 text-[10px] uppercase tracking-[0.2em] text-inkdim">
                <span>© {new Date().getFullYear()} Hitanshu Bhadresh Shah</span>
                <span>Mumbai, India</span>
                <span>Made with intent — every frame</span>
            </div>
        </footer>
    );
}
